import React, { useState } from 'react';
import { t } from 'modules/i18n/intl';
import { Button, makeStyles, Theme } from '@material-ui/core';
import { ToastTooltip } from 'components/ToastTooltip';
import { CorrectIcon } from 'modules/icons/CorrectIcon';

interface ICopyAddressProps {
  address: string;
}

const useStyles = makeStyles<Theme>(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderRadius: theme.spacing(2),
    position: 'relative',
    height: 48,
    backgroundColor: theme.palette.grey.A100,
    padding: theme.spacing(0, 24, 0, 4),
    overflow: 'hidden',
  },
  input: {
    alignItems: 'center',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  button: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 80,
    borderRadius: 0,
  },
}));

export const CopyAddress = ({ address }: ICopyAddressProps) => {
  const classes = useStyles();

  const [copyTooltipOpen, setCopyTooltipOpen] = useState(false);
  const onCopyClicked = () => {
    navigator.clipboard.writeText(address);
    if (copyTooltipOpen) {
      return;
    }
    setCopyTooltipOpen(true);
    setTimeout(() => {
      setCopyTooltipOpen(false);
    }, 3 * 1000);
  };

  return (
    <div className={classes.root}>
      <div className={classes.input}>{address}</div>
      <ToastTooltip
        style={{ width: '100%' }}
        open={copyTooltipOpen}
        message="Copied!"
        icon={<CorrectIcon />}
        placement="top"
      >
        <Button
          variant="contained"
          size="large"
          className={classes.button}
          onClick={onCopyClicked}
        >
          {t('action.copy')}
        </Button>
      </ToastTooltip>
    </div>
  );
};
